import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Header from './components/Header';
import Feed from './components/Feed';
import Profile from './components/Profile';
import EditProfile from './components/EditProfile';
import './App.css';

function AppContent() {
  const { state } = useApp();

  return (
    <div className="app">
      <Header />
      <main className="main">
        {state.view === 'feed' && <Feed />}
        {state.view === 'profile' && <Profile />}
        {state.view === 'edit-profile' && <EditProfile />}
      </main>
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;
